import React from "react";

class DatesParagraph extends React.Component {
    render() {
        return <p className="left-align">{this.props.dates}</p>
    }
}

export default DatesParagraph;